import * as React from 'react';
import { campaignSessionStore, clearGlobalAISourceData, shouldOpenAIDrawer } from './campaignSessionStore';
import { CONTENT_TYPE_MAP, RESOURCE_CONFIG } from './resourceConfig';
import { ResourceType } from './types';

export const useComposerAISource = (targetType: ResourceType) => {
	// Capture before clearing: the clear keeps the drawer from reopening in the next composer, and reading
	// the store after it leaves this one with no source to convert.
	const [{ showingAIAssistant, sourceContent, sourceType }, setAIAssistantState] = React.useState(() => {
		const shouldOpen = shouldOpenAIDrawer();
		const capturedSourceContent = campaignSessionStore.aiSourceContent;
		const capturedSourceType = campaignSessionStore.aiSourceType;
		if (shouldOpen) {
			clearGlobalAISourceData();
		}
		return {
			showingAIAssistant: shouldOpen,
			sourceContent: capturedSourceContent,
			sourceType: capturedSourceType,
		};
	});

	const setShowingAIAssistant = React.useCallback(
		(value: boolean) => setAIAssistantState(prev => ({ ...prev, showingAIAssistant: value })),
		[]
	);

	const initialGeneration = React.useMemo(() => {
		const fromContentType = sourceType ? CONTENT_TYPE_MAP[sourceType as ResourceType] : undefined;
		if (!sourceContent || !fromContentType) {
			return undefined;
		}
		return {
			sourceContent,
			fromContentType,
			toContentType: CONTENT_TYPE_MAP[targetType],
			conversationTitle: RESOURCE_CONFIG[targetType].createDescription(sourceType as ResourceType),
		};
	}, [sourceContent, sourceType, targetType]);

	return { showingAIAssistant, setShowingAIAssistant, sourceContent, sourceType, initialGeneration };
};
